<div fxLayoutAlign="center center">
  <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="16px">
    <mat-spinner [diameter]="32"></mat-spinner>
    <span>Checking partner code...</span>
  </div>
</div>
